import type { SearchCriteria } from '@awazevr/mfe-common.types-and-mocks.site-search-service'

import type { ExplorationTile } from './data'

// Inherited from the user's search; filters are intentionally not carried over.
const PARTY_AND_DATE_PARAMS: Array<keyof SearchCriteria> = [
  'adult',
  'child',
  'infant',
  'pets',
  'nights',
  'range',
  'start',
]

export const buildTileHref = (
  tile: ExplorationTile,
  searchCriteria?: SearchCriteria,
): string => {
  const params = new URLSearchParams()

  params.set('placesId', tile.placesId)
  params.set('regionName', tile.regionName)
  params.set('destinationCategory', tile.destinationCategory)
  params.set('accommodationType', 'cottages')
  params.set('sort', 'recommended')
  params.set('displayMode', 'LIST')
  params.set('page', '1')

  PARTY_AND_DATE_PARAMS.forEach((key) => {
    const value = searchCriteria?.[key]

    if (value !== undefined && value !== null && value !== '') {
      params.set(key, String(value))
    }
  })

  return `/search?${params.toString()}`
}
